import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import React from "react";

export default function AuthCard({ header, children }) {
  const theme = useTheme();

  return (
    <Paper sx={{ overflow: "hidden" }}>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          p: 2,
          textAlign: "center",
        }}
      >
        {header}
      </Box>
      <Box sx={{ p: 2 }}>{children}</Box>
    </Paper>
  );
}
